import React, { ChangeEvent, useCallback, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";

import { BalanceRequestData, BalanceTransactionRequest } from "../../../../models";
import { TransactionType, UpdateBalanceAction } from "../../../../enums";
import { DEFAULT_TAKE, RegexConstants, T } from "../../../../constants";
import { useStore, useTranslation } from "../../../../hooks";
import { setTranslationValues } from "../../../../helpers";
import { Button, Input, Modal } from "../../shared";
import { Toaster } from "../../../containers";

interface BalanceRequestModalProps {}

export const BalanceRequestModal: React.FC<BalanceRequestModalProps> = observer(() => {

  const {
    transactionsStore,
    authStore: { currencyCode },
    modalStore: { setBalanceRequestModal, balanceRequestModal: { data } },
  } = useStore();

  const [pinCode, setPinCode] = useState("");
  const [isVisibility, setIsVisibility] = useState(false);
  const t = useTranslation();

  const getBalanceRequests = useCallback(() => {
    transactionsStore.getBalanceRequestList({skip: 0, take: DEFAULT_TAKE});
  }, []);

  const handleClose = useCallback(() => {
    setBalanceRequestModal({ open: false, data: {} as BalanceTransactionRequest });
  }, []);

  const requestData = useMemo(() => {
    return {
      id: data.id,
      pinCode: +pinCode || null,
    };
  }, [pinCode, data]);

  const handleChangePinCode = useCallback((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = event.target;
    if (RegexConstants.Number.test(value) && value.length <= 5) {
      setPinCode(value);
    }
  }, []);

  const balanceApproveOrReject = useCallback((data: BalanceRequestData, type: UpdateBalanceAction) => {
    transactionsStore.balanceRequestApproveOrReject({...data, action: type}).then(() => {
      Toaster.info({message: T.REQUEST_SUCCESS_ACTION});
      getBalanceRequests();
    }).catch((err) => {
      Toaster.error({ message: err?.errorMessage });
    }).finally(() => {
      handleClose();
    });
  }, []);

    return (
      <Modal
        title={T.BALANCE_MANAGEMENT_REQUEST}
        onClose={handleClose}
      >
        <div className="bl-management-popup">
            <div className="bl-management-popup-body">
                <p className="bl-management-popup-info">
                  {
                    setTranslationValues(data.type === TransactionType.Receive ? t(T.BALANCE_REQUEST_GET_MESSAGE) : t(T.BALANCE_REQUEST_SEND_MESSAGE) , {
                      amount: `${data.amount} ${currencyCode}`,
                      name: data.name,
                    })
                  }
                </p>
              {
                <div className="bl-management-code">
                  {
                    pinCode && (
                      <i
                        onClick={() => setIsVisibility(prev => !prev)}
                        className={`pass-visibility ${isVisibility ? 'icon-eye' : 'icon-eye-off'}`}>
                      </i>
                    )
                  }
                  <Input
                    autoFocus
                    value={pinCode}
                    placeholder={T.PIN}
                    className="popupInput"
                    type={isVisibility ? "text" : `password`}
                    onChange={(event) => handleChangePinCode(event)}
                  />
                </div>
              }
            </div>
          <div className="bl-management-popup-footer">
            <Button
              text={T.DENY}
              className="pp-button for-dis"
              onClick={() => balanceApproveOrReject(requestData, UpdateBalanceAction.Reject)}
            />
            <Button
              text={T.APPROVE}
              className="pp-button active"
              onClick={() => balanceApproveOrReject(requestData, UpdateBalanceAction.Approve)}
            />
            </div>
        </div>
      </Modal>
    );
  },
);
